import Repository from "./masterRepository";

const getEvents = "/masters/events/getAdminEvents";

export default {
  getEvents(payload) {
    return Repository.post(`${getEvents}`, payload);
  },
};
